import React, { useState, useEffect } from "react";
import MasterCouponTable from "./MasterCouponTable";
import MasterCouponHeader from "./MasterCouponHeader";
import MasterCouponAdd from "./MasterCouponAdd";
import MasterCouponEdit from "./MasterCouponEdit";
import MasterCouponImport from "./MasterCouponImport";

import useApiNew from "../../../utils/useApiNew";
import axios from "axios";

import Breadcrumbs from "../../../components/ui/Breadcrumbs";

import DeleteAlert from "../../../components/ui/DeleteAlert";

import Notification, {
  errorNotify,
  successNotify,
} from "../../../Services/Notification";
import { handleGetOneData } from "../../../utils/handleGetOneData";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const couponApiURL = `${process.env.REACT_APP_API_URL}api/coupon-masters`;
const exportScriptApiURL = `${process.env.REACT_APP_API_URL}api/export-couponmaster`;
const addCouponApiUrl = `${process.env.REACT_APP_API_URL}api/coupon-masters`;
const editApiUrl = `${process.env.REACT_APP_API_URL}api/coupon-masters`;
const deleteApiUrl = `${process.env.REACT_APP_API_URL}api/coupon-masters`;

const MasterScript = () => {
  const [renderKey, setRenderKey] = useState(0);
  const [isAdd, setIsAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [isImport, setIsImport] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [globalFilters, setGlobalFilters] = React.useState();
  const [bankData, setBankData] = React.useState();
  const [filter, setFilter] = useState({});
  const [isFilter, setIsFilter] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  let { data, loading } = useApiNew(
    couponApiURL,
    "GET",
    { headers },
    renderKey,
  );

  data = data?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
  }));
  // const data = makeSriptData;
  useEffect(() => {
    if (data) {
      setIsLoading(false);
    } else {
      setIsLoading(true);
    }
  }, [data]);

  //EDIT

  const handleGetOneScript = (id) => {
    return handleGetOneData(data, id);
  };

  const filterBankData = () => {
    let filterData = data;

    if (filter?.status && filter?.status !== "both") {
      filterData = filterData?.filter((item) => item.status === filter?.status);
    }

    if (filter?.bookclose_recorddate || filter?.nse_exdate) {
      if (filter?.bookclose_recorddate && !filter?.nse_exdate) {
        filterData = filterData?.filter(
          (item) => item.eff_start_date >= filter?.bookclose_recorddate,
        );
      }

      if (!filter?.bookclose_recorddate && filter?.nse_exdate) {
        filterData = filterData?.filter(
          (item) => item.eff_end_date <= filter?.nse_exdate,
        );
      }
      if (filter?.bookclose_recorddate && filter?.nse_exdate) {
        filterData = filterData?.filter(
          (item) =>
            item.eff_start_date >= filter?.bookclose_recorddate &&
            item.eff_end_date <= filter?.nse_exdate,
        );
      }
    }
    if (globalFilters) {
      filterData = data.filter(
        (item) =>
          item?.description
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.coupon_code
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.unit?.toLowerCase().includes(globalFilters?.toLowerCase()) ||
          item?.coupon_type
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.value?.toLowerCase().includes(globalFilters?.toLowerCase()),
      );
    }

    setBankData(filterData);
  };
  useEffect(() => {
    filterBankData();
  }, [globalFilters, filter]);

  const handleAddCoupon = async (data) => {
    setIsButtonClicked(true);
    try {
      const res = await axios.post(addCouponApiUrl, data, { headers });
      const resData = res.data;

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT

  const handleEditCoupon = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${editApiUrl}/${segmentId}`;

    try {
      const res = await axios.put(updateAPI, data, { headers });
      const resData = res.data;
      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeleteScript = async () => {
    const deleteAPI = `${deleteApiUrl}/${selectedItemId}`;
    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      console.log(resData);
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  // IMPORT

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportScriptApiURL;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      errorNotify("Something went wrong.");
      setIsDownloadClicked(false);
    }
  };

  // DOWNLOAD
  const handleDownloadScript = async (id) => {
    setIsDownloadClicked(true);
    const filename = `Coupon-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };

  const breadcrumbs = ["Home", "Master", "Coupons"];

  const buttonConfig = {
    value: "script",
    name: "Scrip",
    getOneHandler: handleGetOneScript,
    addHandler: handleAddCoupon,
    editHandler: handleEditCoupon,
    deleteHandler: handleDeleteScript,
    downloadHandler: handleDownloadScript,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };
  const name = "coupon";

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterCouponHeader
        setFilter={setFilter}
        setIsFilter={setIsFilter}
        isFilter={isFilter}
      />
      <MasterCouponTable
        loading={loading}
        tableData={
          globalFilters ||
          filter?.status ||
          filter?.bookclose_recorddate ||
          filter?.nse_exdate
            ? bankData
            : data
        }
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setIsImport={setIsImport}
        setSelectedItemId={setSelectedItemId}
        renderKey={renderKey}
        isLoading={isLoading}
        setGlobalFilters={setGlobalFilters}
        actionPermissions={actionPermissions("masters", "Coupon")}
        setIsFilter={setIsFilter}
        isFilter={isFilter}
        isDownloadClicked={isDownloadClicked}
      />
      {isAdd && (
        <MasterCouponAdd
          buttonConfig={buttonConfig}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isEdit && (
        <MasterCouponEdit
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isImport && (
        <MasterCouponImport
          setIsImport={setIsImport}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterScript;
